const OffersRoutes = {
  getAllOffers: "/marketplace/offers/",
  createOffer: "/marketplace/offers/create",
  updateOffer: "/marketplace/offers/update",
  deleteOffer: "/marketplace/offers/delete",
};

export default OffersRoutes;
